import { render, staticRenderFns } from "./Transporter.vue?vue&type=template&id=a9791394&scoped=true&"
import script from "./Transporter.vue?vue&type=script&lang=js&"
export * from "./Transporter.vue?vue&type=script&lang=js&"
import style0 from "./Transporter.vue?vue&type=style&index=0&id=a9791394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9791394",
  null
  
)

export default component.exports